import '@flowgram.ai/free-layout-editor/index.css';
import './styles/index.css';
import { useState, useEffect } from 'react';

import { EditorRenderer, FreeLayoutEditorProvider } from '@flowgram.ai/free-layout-editor';

import { nodeRegistries } from './nodes';
import { initialData } from './initial-data';
import { getWorkflowDetail, getTaskDetailV2 } from './https';
import { useEditorProps } from './hooks';
import { DemoTools } from './components/tools';
import { SidebarProvider, SidebarRenderer } from './components/sidebar';

export const Editor = () => {
  const [taskData, setTaskData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [taskName, setTaskName] = useState('');
  const editorProps = useEditorProps(taskData || initialData, nodeRegistries);
  // 从URL参数中获取taskId和executorName
  const urlParams = new URLSearchParams(window.location.search);
  const taskId = urlParams.get('taskId') || '';
  const executorName = urlParams.get('executorName') || '';

  useEffect(() => {
    const fetchTaskDetail = async () => {
      setIsLoading(true);
      try {
        // 获取任务详情(任务名称)
        if (taskId) {
          try {
            const taskDetail = await getTaskDetailV2({ taskId });
            const name = taskDetail.name || '未命名任务';
            setTaskName(name);
            // 更新页面标题
            document.title = `编辑工作流-${name}`;
          } catch (error) {
            console.error('获取任务名称失败:', error);
            // 失败时使用默认标题,不影响编辑器正常使用
          }
        }

        const res = await getWorkflowDetail({ taskId, executorName });
        const { taskNodes, nodeRelations } = res;

        const transformedNodes = taskNodes.map((node: any) => ({
          id: node.id,
          type: node.type,
          meta: {
            position: node.meta,
          },
          data: {
            title: node.name,
            fields: Object.keys(node.config || {}).map((key) => ({
              key: key,
              value: node.config[key],
            })),
          },
        }));

        const transformedEdges = nodeRelations.map((edge: any) => ({
          sourceNodeID: edge.source,
          targetNodeID: edge.target,
        }));

        const data = {
          nodes: transformedNodes,
          edges: transformedEdges,
        };

        const modifiedInitialData: any = {
          ...initialData,
          // 移除原有的开始到结束的边
          nodes: data.nodes && data.nodes.length ? [...data.nodes] : initialData.nodes,
          edges: data.edges && data.edges.length ? [...data.edges] : initialData.edges,
        };

        setTaskData(modifiedInitialData);
      } catch (error) {
        console.error('获取任务详情失败:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTaskDetail();
  }, [taskId]);

  if (isLoading) {
    return <div>加载中...</div>;
  }

  // console.log('editorProps', editorProps);

  return (
    <div className="doc-free-feature-overview">
      <FreeLayoutEditorProvider {...editorProps}>
        <SidebarProvider>
          <div className="demo-container">
            <EditorRenderer className="demo-editor" />
          </div>
          <DemoTools taskName={taskName} />
          <SidebarRenderer />
        </SidebarProvider>
      </FreeLayoutEditorProvider>
    </div>
  );
};
